import React, { useEffect, useState  } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import "../css/VariantDetails.css";
import Loading from "./Loading";
import VariantHeader from "./VariantHeader";
import VariantInfo from "./VariantInfo";
import VariantPlan from "./VariantPlan";
import api from "../services/api";
import Clauses from "./Clauses";
import RegistrationStatus from "./RegistrationStatus";

const VariantDetails = () => {
  const { tripGuid, variantGuid } = useParams();
  const navigate = useNavigate();
  const [variantDetails, setVariantDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const fetchVariantDetails = async () => {
      try {
        const details = await api.getVariant(tripGuid, variantGuid, searchParams);
        setVariantDetails(details);
      } catch (error) {
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchVariantDetails();
  }, [tripGuid, variantGuid, searchParams]);

  if (isLoading) {
    return <Loading />;
  }

  if (!variantDetails) {
    return (
      <div className="variant-details-error">
        <p>Nie udało się załadować szczegółów wariantu.</p>
        <button onClick={() => navigate(-1)} className="back-button">
          Powrót
        </button>
      </div>
    );
  }

  return (
    <div className="variant-details">
      <VariantHeader variantDetails={variantDetails} />
      <RegistrationStatus registrationStatus={variantDetails.registrationStatus} guid={variantDetails.code} />
      <VariantInfo variantDetails={variantDetails} />
      <div className="variant-note">
        <p style={{margin: 'unset'}}>
          <strong>Czy wiesz, że Tęczowa Drużyna to oddolna inicjatywa non-profit?</strong><br />
          Na wycieczkach nie zarabia ani Stowarzyszenie, ani osoby koordynujące wycieczki. <br />
          <a
            href="https://www.teczowadruzyna.org/wspieraj/jak-nas-wesprze%C4%87"
            target="_blank"
            rel="noopener noreferrer"
          >
            Poznaj nas i wesprzyj nasze działania »
          </a>
        </p>
      </div>
      <VariantPlan tripPlan={variantDetails.tripPlan} />
      <Clauses
        isTouristEvent={variantDetails.isTouristEvent}
        minRegistrationsNumber={variantDetails.minRegistrationsNumber}
        cancelationTripFinalDate={variantDetails.cancelationTripFinalDate}
      />
    </div>
  );
};

export default VariantDetails;
